import { Environment } from '@dice/app/types/env.type';
import { DEV_ENV_CONFIG } from '@dice/environments/dev/dev.env';
import { NgxLoggerLevel } from 'ngx-logger';

export const DEV_BLUE_ENV_CONFIG: Environment = {
  ...DEV_ENV_CONFIG,
  hostNames: ['dice-dev-blue.dev-scapp-corp.swisscom.com', 'dice-ui-blue-green-dev.dev-scapp-corp.swisscom.com'],
  enableDebugInfo: true,
  isProduction: false,
  variant: 'dice-ui-dev-blue',
  logLevel: NgxLoggerLevel.DEBUG,
};
